import React from "react";
import Error500 from "@/pages/Error500";

interface State {
  hasError: boolean;
  errorId: string | null;
}

export class AppErrorBoundary extends React.Component<
  React.PropsWithChildren<{}>,
  State
> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError(): State {
    const errorId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID().slice(0, 8)
        : `${Date.now()}`;
    return { hasError: true, errorId };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[AppErrorBoundary]", error, info);
    try {
      // Fail-safe Sentry capture – only if Sentry is loaded
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      import("@sentry/react").then((Sentry) => {
        Sentry.captureException(error, { contexts: { react: { componentStack: info.componentStack ?? undefined } } });
      }).catch(() => {});
    } catch {
      // noop
    }
  }

  render() {
    if (this.state.hasError) {
      return <Error500 errorId={this.state.errorId ?? undefined} />;
    }
    return this.props.children;
  }
}
